// extracted by mini-css-extract-plugin
module.exports = {"schedules":"Vesting_schedules__2Px5u","button":"Vesting_button__3n7_T"};